// @flow
/* -----------------Globals--------------- */
import React from 'react';

/* -----------------UI--------------- */
import { withStyles } from '@material-ui/core/styles';
import { Card, CardContent } from '@material-ui/core/';

/* -----------------Styles--------------- */
const styles = theme => ({
  card: {
    marginBottom: theme.spacing(1),
  },
  cardContent: {
    display: 'flex',
    flexDirecton: 'row',
    padding: theme.spacing(3, 2, 3, 2),
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
});

/* -----------------Type declarations--------------- */
type Classes = {
    card: string,
    cardContent: string,
};

/* -----------------Props--------------- */
type Props = {
    classes: Classes,
    children: *,
};

/* -----------------Component--------------- */
const TermCardWrapper = (props: Props) => {
  const {
    classes,
    children,
  } = props;

  return (
    <Card
      className={classes.card}
      elevation={0}
    >
      <CardContent
        className={classes.cardContent}
      >
        {children}
      </CardContent>
    </Card>

  );
};

export default withStyles(styles)(TermCardWrapper);
